<template>
  <div id="letter-from-our-board-chair" class="section-content">
    <div class="grid-container">
      <div class="board-chair grid-x align-center">
        <div class="cell medium-10 large-8 xlarge-12 board-chair__wrapper">
          <div class="grid-x grid-margin-x">
            <div class="cell xlarge-6">
              <h2 data-aos="fade-right">A Letter from our Board Chair</h2>
              <div class="board-chair__info">
                <div class="board-chair__photo"
                     data-aos="zoom-out"
                     data-aos-delay="200"
                     data-aos-duration="1000"
                     data-aos-offset="100">
                  <img src="../../assets/board-chair.png"
                       alt="Chair of the Board"/>
                </div>
                <div class="board-chair__subtext"
                     data-aos="fade-in"
                     data-aos-delay="400"
                     data-aos-duration="1000"
                     data-aos-offset="100">
                  <h5>Hugh Francis, III, MD</h5>
                  <p>Chair of the Board</p>
                </div>
              </div>
            </div>
            <div class="cell xlarge-6">
              <div class="board-chair__letter"
                   data-aos="fade-left"
                   data-aos-delay="600"
                   data-aos-duration="1000"
                   data-aos-offset="100">
                <p>
                  This 2019 annual report was prepared prior to the coronavirus public health emergency. How our world
                  has changed! This report highlights doctors who, like you, strive to improve the lives of so many.
                  Hopefully it will be enjoyable to learn about your colleagues and their contributions to their
                  communities. Also included is a financial summary of SVMIC’s 2019 business operations.
                </p>
                <p>
                  SVMIC succeeds when its policyholders are successful, and its policyholders are feeling remarkable
                  pressure right now. So, in an unprecedented move, SVMIC’s Board of Directors this year have decided to
                  suspend all planned rate increases. We are also waiving all fees for self-study risk management
                  courses for the balance of 2020. If your practice’s financial situation prohibits timely payment of
                  your premium, or if your practice volume has been significantly reduced, please contact our
                  underwriting department to assess ways we can help you through this challenge. SVMIC’s mission is to
                  protect, support, and advocate for physicians and advanced practice professionals so that they can
                  provide the best possible patient care. The need for that care is particularly urgent right now.
                  Please call if we can help or access our clinical resources at
                  <a href="https://svmic.com/COVID-19">SVMIC.com/COVID-19</a>.
                </p>
                <p>
                  Thank you for your hard work during this difficult time for our community. Please know that as we work
                  through this public health emergency, one thing remains constant: SVMIC is committed to helping its
                  physicians and advanced practice professionals be successful. If there is anything this company can do
                  to better serve you, please let us know.
                </p>
                <div class="board-chair__subtext board-chair__signature">
                  <h5>Hugh Francis, III, MD</h5>
                  <p>chair of the board</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeLetter'
};
</script>

<style lang="scss" scoped>
  @import "../../styles/setup/variables";

  .board-chair {
    margin: 40px 0;

    .board-chair__wrapper {
      padding: 0 15px;
    }

    .board-chair__info {
      margin: 40px 0;

      .board-chair__photo {
        display: inline-block;
        height: 125px;
        width: 125px;
        margin: 0 40px 0 0;

        img {
          padding-bottom: 40px;
        }
      }

      @include breakpoint(small only) {
        .board-chair__subtext {
          padding-left: 10px;
        }
      }
    }

    .board-chair__letter {
      color: #424242;

      h2 {
        margin-bottom: 40px;
      }

      p:not(:last-child) {
        margin-bottom: 35px;
      }

      .board-chair__signature {
        padding-top: 10px;

        &::before {
          border-bottom: 5px solid $purp;
          bottom: 0;
          content: "";
          display: block;
          left: 0;
          padding: 0;
          width: 45px;
        }
      }
    }
  }

  .board-chair__subtext {
    display: inline-block;
    color: #424242;

    h5 {
      margin: 45px 0 5px;
      font-size: 23px;
    }

    p {
      font-family: $sans-serif;
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
      letter-spacing: 2px;
      margin: 0;
      text-transform: uppercase;
    }
  }

</style>
